import { render, staticRenderFns } from "./ArticleDepartmentsList.vue?vue&type=template&id=2e9c0f32&scoped=true"
import script from "./ArticleDepartmentsList.vue?vue&type=script&lang=js"
export * from "./ArticleDepartmentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9c0f32",
  null
  
)

export default component.exports